import { Paper, withStyles } from '@material-ui/core';
import React from 'react';
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"

const styles = theme => ({
    root: {
        marginLeft: theme.spacing(-0.5),
        marginRight: theme.spacing(-0.5),
        marginTop: theme.spacing(-1),
        paddingTop: theme.spacing(1)
    }
});

const Documentation = props => {
    const { specs, classes } = props;

    return (
        <Paper className={classes.root} >
            <SwaggerUI spec={specs} />
        </Paper>
    )
}

export default (withStyles(styles)(Documentation));